import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError, MASCOT } from "@/lib/api";
import { AuthShell, AuthField } from "@/components/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Se o e-mail existir, enviamos as instruções.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Recuperar senha"
      subtitle="Vamos te ajudar a voltar pra dentro."
      mascot={MASCOT.tilt}
      footer={<Link to="/login" className="text-[#f0791f] font-semibold">Voltar ao login</Link>}
    >
      {sent ? (
        <p className="text-center text-[#5c4634]" data-testid="forgot-sent-message">
          Prontinho! Se houver uma conta com esse e-mail, o link de recuperação foi enviado.
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <AuthField label="E-mail" testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="voce@email.com" required />
          <button type="submit" disabled={loading} className="btn-orange w-full py-3.5 rounded-full font-semibold disabled:opacity-60" data-testid="forgot-submit">
            {loading ? "Enviando..." : "Enviar link de recuperação"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
